const getStepStatus = (isStepActive, isStepComplete) => {
    if (isStepActive)
        return 'Current Step';
    if (isStepComplete)
        return 'Complete';
    return undefined;
};
export const a11y = {
    getAriaLabelStepTitle: ({ stepNumber, stepTitle, isStepActive, isStepComplete, }) => {
        const stepStatus = getStepStatus(isStepActive, isStepComplete);
        const formattedStatus = stepStatus ? ` - ${stepStatus}` : '';
        return `Step ${stepNumber}: ${stepTitle}${formattedStatus}`;
    },
    getAriaLiveSetNextStepActive: (currentStep, currentTitle, nextStep, nextTitle) => {
        return `Step ${currentStep}: ${currentTitle} - Complete. Step ${nextStep}: ${nextTitle} - Current Step.`;
    },
};
//# sourceMappingURL=strings.js.map